import callAPI from 'api'

import {
  CreateApiKeyPayload,
  CreateApiKeyResponse,
  GetApiKeyPayload,
  GetApiKeyResponse,
  GetApiKeysPayload,
  GetApiKeysResponse,
  UpdateApiKeyPayload,
  UpdateApiKeyResponse,
  UpdateApiKeyStatusPayload,
  UpdateApiKeyStatusResponse,
} from './types/api-key'

export const createApiKey = async (payload: CreateApiKeyPayload) =>
  await callAPI<CreateApiKeyResponse, CreateApiKeyPayload>('crm_create_external_api_key', [payload], {
    requireAuthorization: true,
    reloadOnReauth: false,
  })

export const getApiKey = async (payload: GetApiKeyPayload) =>
  await callAPI<GetApiKeyResponse, GetApiKeyPayload>('crm_get_external_api_key_details', [payload], {
    requireAuthorization: true,
  })

export const getApiKeys = async (payload: GetApiKeysPayload) =>
  await callAPI<GetApiKeysResponse, GetApiKeysPayload>('crm_get_external_api_keys', [payload], {
    requireAuthorization: true,
  })

export const updateApiKey = async (payload: UpdateApiKeyPayload) =>
  await callAPI<UpdateApiKeyResponse, UpdateApiKeyPayload>('crm_update_external_api_key', [payload], {
    requireAuthorization: true,
    reloadOnReauth: false,
  })

export const updateApiKeyStatus = async (payload: UpdateApiKeyStatusPayload) =>
  await callAPI<UpdateApiKeyStatusResponse, UpdateApiKeyStatusPayload>('crm_set_external_api_key_status', [payload], {
    requireAuthorization: true,
  })
